import { AsinsTable } from './asins-table';

export { AsinsTable };
